import React from "react";
import ShowQuestionApiCognitive from "./components/ShowQuestionApiCognitive";
import { getRetrieval } from "./api/RetrievalsApi";
import { addMessage } from "./api/MessagesApi";
import { addFeedback, addFeedback2, matrixMode } from "./api/QuestionsApi";

function App(props) {
  return (
    <div className="m-0 p-0 w-full h-full">
      <ShowQuestionApiCognitive
          getRetrieval={getRetrieval}
          retrievalId={props.retrievalId}
          addQuestionRetData={props.addQuestionRetData}
          addMessage={addMessage}
          logo={props.logo}
          chat={props.chat}
          otherRefs={props.otherRefs}
          addFeedback={addFeedback}
          addFeedback2={addFeedback2}
          matrix_mode={props.matrix_mode}
          addMatrixMode={matrixMode}
          colors={props.colors}
          allow_files={props.allow_files}
          language={props.language}
        />
    </div>
  );
}

export default App;
